import { CompanyEnum, InvoiceTypeEnum, ProductSelectionEnum } from "../../../enums";

export const INVOICE_TYPE_OPTIONS = [
  { label: "Monthly", value: InvoiceTypeEnum.MONTHLY },
  { label: "Custom", value: InvoiceTypeEnum.CUSTOM },
];

export const MONTH_OPTIONS = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const COMPANY_OPTIONS = [
  { label: "SCI", value: CompanyEnum.SCI },
  { label: "GUI", value: CompanyEnum.GUI },
  { label: "LDO", value: CompanyEnum.LDO },
];

export const PRODUCT_OPTIONS = [
  { label: "All Products", value: ProductSelectionEnum.ALL_PRODUCTS },
  { label: "Diesel", value: ProductSelectionEnum.DIESEL },
  { label: "Gas 91", value: ProductSelectionEnum.GAS91 },
  { label: "Gas 95", value: ProductSelectionEnum.GAS95 },
  { label: "Gas 97", value: ProductSelectionEnum.GAS97 },
  { label: "Non-Fuel", value: ProductSelectionEnum.NON_FUEL },
];

export const PRODUCT_CODE_LABEL_MAP = {
  [ProductSelectionEnum.DIESEL]: "Diesel",
  [ProductSelectionEnum.GAS91]: "Gas 91",
  [ProductSelectionEnum.GAS95]: "Gas 95",
  [ProductSelectionEnum.GAS97]: "Gas 97",
  [ProductSelectionEnum.NON_FUEL]: "Non-Fuel",
  nonfuel: "Non-Fuel",
};

export const SEARCH_MAX_LENGTH = 75;
export const VAT_DIVISOR = 1.12;
export const VAT_RATE = 0.01;

